import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import ThreeDSSpinner from './ThreeDSSpinner'
import ThreeDSDeviceDataCollection from './ThreeDSDeviceDataCollection';
import ThreeDSIframe from './ThreeDSIframe';
import AppActions from '../../actions/AppActions';
import _get from 'lodash/get';
import $ from 'jquery';
import * as FPT from '../../utility/fpt';

class ThreeDSContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showThreeDSIframe: false,
			showThreeDSSpinner: false,
			showThreeDSDeviceDataCollection: false,
			threeDSDCCStartTime: null
		}
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(undefined);
	}

	initializeThreeDS() {
		let startTime = new Date().getTime();
		this.setState({
			showThreeDSDeviceDataCollection: true,
			showThreeDSSpinner: true,
			threeDSDCCStartTime: startTime
		});
		
		const threeDSRespDuration = {
			dcc_start_time: startTime,
			spinner_start_time: startTime
		}
		FPT.add3DSRespDuration(threeDSRespDuration, window.fpti.pgrp, window.fpti.page);
	}

	handleThreeDSDDCComplete = () => {
		this.setState({
			showThreeDSDeviceDataCollection: false
		});
		
		const threeDSDCCEndTime = new Date().getTime();
		const threeDSRespDuration = {
			dcc_start_time: this.state.threeDSDCCStartTime,
			dcc_end_time: threeDSDCCEndTime,
			spinner_start_time: this.state.threeDSDCCStartTime,
			spinner_end_time: threeDSDCCEndTime,
		}
		FPT.add3DSRespDuration(threeDSRespDuration, window.fpti.pgrp, window.fpti.page);

		this.resolveThreeDSContingency();
	}

	resolveThreeDSContingency = () => {
		const lookup_start_time = new Date().getTime();
		$.post('/donate/guest/resolve-threeds-contingency', (result) => {
			const threeDSRespDuration = {
				lookup_start_time: lookup_start_time,
				lookup_end_time: new Date().getTime()
			}
			FPT.add3DSRespDuration(threeDSRespDuration, window.fpti.pgrp, window.fpti.page);
			
			const threeDSContingency = _get(result, 'data.threeDSContingency');

			if (_get(threeDSContingency, 'threeDSContingencyResolved')) {
				// 3DS Contingency resolved without StepUp Auth
				this.props.onThreeDSStepUpAuthNotRequired();

				this.setState({
					showThreeDSSpinner: false
				})
				return;
			}
			// Save threeDS data and show 3DS iframe
			AppActions.updateThreeDSData(threeDSContingency);
			this.showThreeDSIframe(true);

		}).fail(() => {
			// Clear 3DS data
			AppActions.updateThreeDSData({});
			this.showThreeDSIframe(false);
			this.props.onThreeDSFailure();
		})
	}

	handleThreeDSStepUpAuthComplete = ({ confirmationStatus = false, error }) => {
		if (confirmationStatus && confirmationStatus === 'threeDS-success') {
			this.props.onThreeDSStepUpAuthSuccess();
		} else {
			this.props.onThreeDSStepUpAuthFailure();
			return;
		}
	}

	showThreeDSIframe = (show) => {
		this.setState({
			showThreeDSIframe: show
		});
	}

	render() {

		return (
			<div>
				{this.state.showThreeDSSpinner &&
					<Portal>
						<ThreeDSSpinner />
					</Portal>
				}

				{
					this.state.showThreeDSDeviceDataCollection &&
					<ThreeDSDeviceDataCollection
						onThreeDSDDCComplete={this.handleThreeDSDDCComplete}
					/>
				}

				{
					this.state.showThreeDSIframe &&
					<ThreeDSIframe
						onStepUpAuthComplete={this.handleThreeDSStepUpAuthComplete}
					/>
				}
			</div>
		);
	}
}

ThreeDSContainer.propTypes = {
	onThreeDSStepUpAuthNotRequired: PropTypes.func,
	onThreeDSStepUpAuthSuccess: PropTypes.func,
	onThreeDSStepUpAuthFailure: PropTypes.func,
	onThreeDSFailure: PropTypes.func,
	onRef: PropTypes.func,
	toggleSpinner: PropTypes.func
}

export default ThreeDSContainer;



// WEBPACK FOOTER //
// ./components/threeDS/ThreeDSContainer.js